module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/training-unit-lvl3-100.deb5fa3b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/training-unit-lvl3-100.png
// module id = 3567
// module chunks = 11